<script setup>
import { computed, watch, getCurrentInstance } from 'vue';
import { useCounter } from '@rebuild/hooks/useCountDown';
const { proxy } = getCurrentInstance();

const props = defineProps({
  time: {
    type: Number,
    default: 0,
  },
  endTime: {
    type: Number,
    default: 0,
  },
});



const getDHMS = (time, padZeroOption = false) => {
  let day = Math.floor(time / (24 * 3600));
  let hour = Math.floor((time % (24 * 3600)) / 3600);
  let minute = Math.floor((time % 3600) / 60);
  let second = Math.floor(time % 60);
  if (padZeroOption) {
    day = padZero(day);
    hour = padZero(hour);
    minute = padZero(minute);
    second = padZero(second);
  }
  return { day, hour, minute, second };
}

const padZero = (value) => {
  return value.toString().padStart(2, '0');
}



const emits = defineEmits(['end']);
const { count, resume, pause, start } = useCounter();
const timeArr = computed(() => {
  const { day, hour, minute, second } = getDHMS(count.value, true);
  if (count.value == 0) {
    pause();
  }
  const arr = [
    {
      label: proxy.$t('enterprise.activity.hour'),
      value: hour,
    },
    {
      label: proxy.$t('enterprise.activity.minute'),
      value: minute,
    },
    {
      label: proxy.$t('enterprise.activity.second'),
      value: second,
    },  
  ];
  if (day !== '00') {
    arr.unshift({
      label: proxy.$t('enterprise.activity.day'),
      value: day,
    });
  }

  return arr;
});

watch(
  () => props.time,
  () => {
    // 毫秒转秒
    pause();
    const time = Math.floor(props.time / 1000);
    start(time);
  },
  { immediate: true },
);

watch(
  () => count.value,
  (val) => {
    if (val === 0) {
      console.log('倒计时结束');
      emits('end');
    }
    if (props.endTime) {
      const now = new Date().getTime();
      if (now > props.endTime) {
        emits('end');
      }
    }
  },
);
</script>

<template>
  <div class="meeting-counter">
    <div v-for="item in timeArr" :key="item.label" class="meeting-counter__item">
      <span class="value">{{ item.value }}</span
      ><span class="label">{{ item.label }}</span>
    </div>
  </div>
</template>
<style lang="less" scoped>
.meeting-counter {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  &__item {
    font-size: 16px;

    margin-right: 12px;
    display: flex;
    align-items: center;
    &:last-of-type {
      margin-right: 0;
    }
    .value {
      display: inline-flex;
      height: 40px;
      width: 40px;
      border-radius: 4px;
      border: 1px solid rgba(0, 0, 0, 0.10);
      color: var(--theme-color);
      font-weight: 700;
      font-size: 24px;
      font-family: 'DIN Alternate';
      margin-right: 12px;
      justify-content: center;
      align-items: center;
    }
    .label {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.60);
    }
  }
}
</style>
